import { useAuth } from '../../auth';
import { useSiteAvailability } from '../site/SiteAvailability';

export const useTippingAccess = () => {
  const { user } = useAuth();
  const site = useSiteAvailability();
  const mode = site?.settings?.tipping_mode;
  if (!user) return { allowed: false, message: 'Log in to send V-credit tips.' };
  if (!mode || site.error) return { allowed: false, message: site?.error || 'Checking tipping availability…' };
  if (mode === 'disabled') return { allowed: false, message: 'Tipping is temporarily disabled. Existing transfers can still finish.' };
  if (mode === 'admin_only' && user.role !== 'admin') return { allowed: false, message: 'Tipping is currently available to administrators only.' };
  return { allowed: true, message: '' };
};